module.exports = __webpack_public_path__ + "img/italic.62821151.svg";